import { render, staticRenderFns } from "./CardboxBlog.vue?vue&type=template&id=03d64292&scoped=true&"
import script from "./CardboxBlog.vue?vue&type=script&lang=js&"
export * from "./CardboxBlog.vue?vue&type=script&lang=js&"
import style0 from "./CardboxBlog.vue?vue&type=style&index=0&id=03d64292&scoped=true&lang=css&"
import style1 from "./CardboxBlog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d64292",
  null
  
)

export default component.exports